import { Palette } from '@/themes/themeOverrides/Palette';

const nestedAccent = [Palette.yellow.yellow400, Palette.yellow.yellow300, Palette.yellow.yellow200, Palette.yellow.yellow100];

export const parameterSubsetGroupStyles = depth => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: '16px',
    padding: '16px',
    boxSizing: 'border-box',
    borderRadius: '12px',
    border: `1px solid ${Palette.gray.gray200}`,
    borderLeft: `2px solid ${nestedAccent[Math.min(depth, nestedAccent.length - 1)]}`,
    backgroundColor: depth % 2 === 0 ? Palette.gray.gray50 : Palette.white,
});

export const parameterSubsetActionsStyles = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '8px',
    marginTop: '8px',
};

export const parameterSubsetHeaderStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '4px',
};

export const parameterSubsetSwitchesStyles = {
    marginLeft: '10px',
};

export const parameterSubsetListStyles = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
};

export const parameterDetailsStyles = {
    padding: '2px',
    width: '100%',
    boxSizing: 'border-box',
    '& .parameter-details-loading': {
        display: 'flex',
        justifyContent: 'center',
        padding: '24px 0',
    },
    '& .parameter-exception-empty': {
        margin: 0,
    },
    '& .RaDatagrid-root .RaDatagrid-tableWrapper': {
        maxWidth: '100%',
        borderRadius: '12px',
        '& .RaDatagrid-thead': {
            pointerEvents: 'none',
        },
        '& .RaDatagrid-selectable:hover': {
            '& .MuiTableCell-root.column-type': {
                boxShadow: `1px 0 0 0 ${Palette.gray.gray50}, -2px 0 0 0 ${Palette.gray.gray300}, 0 -2px 0 0 ${Palette.gray.gray300}, 0 2px 0 0 ${Palette.gray.gray300}`,
            },
        },
    },
};

export const parameterExceptionListStyles = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    backgroundColor: Palette.white,
    '& .parameter-exception-nested-title': {
        marginBottom: '8px',
        fontWeight: 600,
    },
    '& .MuiTableBody-root .RaDatagrid-row': {
        '& .MuiTableCell-root': {
            backgroundColor: '#fbfbfb',
        },
    },
    '& .RaDatagrid-table td:last-child, & .RaDatagrid-table th:last-child': {
        position: 'static !important',
        '&::before': {
            display: 'none',
        },
        '&.MuiTableCell-root::after': {
            display: 'none',
        },
    },
};

export const parameterExceptionNestedStyles = depth => ({
    margin: '8px 0 8px 0',
    paddingLeft: '8px',
    boxSizing: 'border-box',
    borderLeft: `2px dashed ${nestedAccent[Math.min(depth, nestedAccent.length - 1)]}`,
    backgroundColor: Palette.white,
});

export const parameterSubsetTreeStyles = {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
    padding: '24px 0 8px',
    boxSizing: 'border-box',
    '& .parameter-subset-tree-title': {
        margin: '0 0 4px',
    },
};

export const parameterSubsetTreeNodeStyles = depth => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: 0,
    padding: '16px',
    boxSizing: 'border-box',
    borderRadius: '12px',
    border: `1px solid ${Palette.gray.gray200}`,
    borderLeft: `2px solid ${nestedAccent[Math.min(depth, nestedAccent.length - 1)]}`,
    backgroundColor: depth % 2 === 0 ? Palette.gray.gray50 : Palette.white,
    '&.is-inactive': {
        opacity: 0.7,
    },
    '& .parameter-subset-tree-header': {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: '16px',
        flexWrap: 'wrap',
    },
    '& .parameter-subset-tree-scope': {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        minWidth: 0,
        flex: 1,
    },
    '& .parameter-subset-tree-type .MuiTypography-root': {
        fontWeight: 600,
        textTransform: 'capitalize',
    },
    '& .parameter-subset-tree-targets .MuiBox-root': {
        maxWidth: '100% !important',
    },
    '& .parameter-subset-tree-value': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: '2px',
        '& .MuiTypography-caption': {
            color: Palette.gray.gray600,
        },
        '& .MuiTypography-body2': {
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: '24px',
        },
    },
    '& .parameter-subset-tree-meta': {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '16px',
        marginTop: '12px',
        '& .parameter-subset-tree-flag': {
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            '& .MuiTypography-root': {
                fontSize: '12px',
                lineHeight: '16px',
                color: Palette.gray.gray700,
            },
        },
    },
    '& .parameter-subset-tree-children': {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        marginTop: '12px',
        paddingLeft: '12px',
        borderLeft: `2px dashed ${nestedAccent[Math.min(depth + 1, nestedAccent.length - 1)]}`,
    },
});
